export default [
  {
    path: '/playlist/list',
    name: 'playlist-list',
    component: () => import('@/views/playlist/index.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Playlist',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Playlist' }, { title: 'Playlist', active: true }],
      permissions: ['playlist_list']
    }
  }
]
